export default "__VITE_ASSET__40acadb2__"